/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Settings",
  size: 20
}

const SvgSettings = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <ellipse fill="none" cx={6.11} cy={3.55} rx={2.11} ry={2.15} />
    <ellipse fill="none" cx={6.11} cy={15.55} rx={2.11} ry={2.15} />
    <circle fill="none" cx={13.15} cy={9.55} r={2.15} />
    <path d="M1 3h3v1H1zM10 3h8v1h-8zM1 9h8v1H1zM15 9h3v1h-3zM1 15h3v1H1zM10 15h8v1h-8z" />
  </Svg>
)

SvgSettings.defaultProps = defaultProps
export default SvgSettings
